export const routes = {
  adminCompaniesDepartments: (id: string) => `/companies/${id}/departments`,
  rota: "/rota",
  rotaTemplateEdit: (id: string) => `/rota/templates/${id}/edit`,
  manageEmployeeTags: "/manage-team/employee-tags",
  companyManageDepartments: "/manage-team/departments",
  manageLocations: "/manage-team?pageTab=location",
  knowledgeBase: "/knowledge-base",

  userCompanyPlatformFunctionality: "/manage-team/settings",
  profile: "/profile",
} as const

export enum eRoutes {
  "/" = "/",

  // Session
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  "/sign-in" = "/",
  "/profile" = "/profile",
  "/sign-up" = "/sign-up",
  "/forgot-password" = "/forgot-password",
  "/reset-password" = "/reset-password",

  "/tools" = "/tools",
  "/questions" = "/questions",
  "/questions/:id" = "/questions/:id",
  "/questions/:id/delete" = "/questions/:id/delete",
  "/questions/new" = "/questions/new",
  "/question-sets" = "/question-sets",
  "/question-sets/new" = "/question-sets/new",
  "/question-sets/:id" = "/question-sets/:id",
  "/flows/new" = "/flows/new",
  "/progress-tags" = "/progress-tags",
  "/progress-tags/new" = "/progress-tags/new",
  "/progress-tags/:id" = "/progress-tags/:id",
  "/flows/new/:id" = "/flows/new/:id",
  "/results" = "/results",
  "/my-rota" = "/my-rota",
  "/my-actions" = "/my-actions",
  "/case-coaching/:resultId" = "/case-coaching/:resultId",
  "/case-coaching/:id/results" = "/case-coaching/:id/results",
  "/files" = "/files",
  "/files/:id" = "/files/:id",
  "/files/:id/edit" = "/files/:id/edit",
  "/tasks" = "/tasks",
  "/holiday-requests" = "/holiday-requests",
  "/sickness-logs" = "/sickness-logs",
  "/flow-comments" = "/flow-comments",
  "/help-videos" = "/help-videos",
  "/reports" = "/reports",

  // User
  "/manage-team" = "/manage-team",
  "/manage-team/files" = "/manage-team/files",
  "/manage-team/sub-companies" = "/manage-team/sub-companies",
  "/manage-team/sub-companies/new" = "/manage-team/sub-companies/new",
  "/manage-team/sub-companies/:id" = "/manage-team/sub-companies/:id",
  "/manage-team/teams" = "/manage-team/teams",
  "/manage-team/teams/:id" = "/manage-team/teams/:id",
  "/manage-team/teams/:id/employees" = "/manage-team/teams/:id/employees",
  "/manage-team/teams/:id/employees/import" = "/manage-team/teams/:id/employees/import",
  "/manage-team/teams/:id/users" = "/manage-team/teams/:id/users",
  "/manage-team/teams/:id/cases" = "/manage-team/teams/:id/cases",
  "/manage-team/teams/:id/edit" = "/manage-team/teams/:id/edit",
  "/manage-team/teams/:id/delete" = "/manage-team/teams/:id/delete",
  "/manager/employees" = "/manager/employees",
  "/manager/employees/:id" = "/manager/employees/:id",
  "/manager/employees/new" = "/manager/employees/new",
  "/manager/employees/import" = "/manager/employees/import",
  "/manager/employees/bulk-archive" = "/manager/employees/bulk-archive",
  "/manager/users" = "/manager/users",
  "/manager/users/:id" = "/manager/users/:id",
  "/manager/users/new" = "/manager/users/new",
  "/manager/users/import" = "/manager/users/import",
  "/manager/users/bulk-archive" = "/manager/users/bulk-archive",
  "/manage-team/help-requests" = "/manage-team/help-requests",
  "/manage-team/help-requests/:id" = "/manage-team/help-requests/:id",
  "/manage-team/billing" = "/manage-team/billing",
  "/absences" = "/absences",
  "/probations" = "/probations",
  "/flows-intro" = "/flows-intro",
  "/hr-profiles" = "/hr-profiles",
  "/hr-profiles/:id" = "/hr-profiles/:id",
  "/hr-profiles/:id/request" = "/hr-profiles/:id/request",
  "/hr-profiles/:id/delete" = "/hr-profiles/:id/delete",
  "/hr-profiles/new" = "/hr-profiles/new",
  "/hr-profiles/sort" = "/hr-profiles/sort",
  "/hr-team" = "/hr-team",
  "/recruitment" = "/recruitment",

  "/manage-team/fourth" = "/manage-team/fourth",
  "/manage-team/itrent" = "/manage-team/itrent",

  "/reports/cases" = "/reports/cases",
  "/reports/overtime" = "/reports/overtime",
  "/reports/time-taken" = "/reports/time-taken",

  "/teams" = "/teams",
  "/teams/:id" = "/teams/:id",
  "/teams/:id/employees" = "/teams/:id/employees",
  "/teams/:id/employees/import" = "/teams/:id/employees/import",
  "/teams/:id/users" = "/teams/:id/users",
  "/teams/:id/cases" = "/teams/:id/cases",
  "/teams/:id/edit" = "/teams/:id/edit",
  "/teams/:id/delete" = "/teams/:id/delete",

  // Admin
  "/companies/:id" = "/companies/:id",
  "/companies/:id/alerts" = "/companies/:id/alerts",
  "/companies/:id/archive" = "/companies/:id/archive",
  "/companies/:id/details" = "/companies/:id/details",
  "/companies/:id/employees" = "/companies/:id/employees",
  "/companies/:companyId/employees/:id" = "/companies/:companyId/employees/:id",
  "/companies/:companyId/users/:id" = "/companies/:companyId/users/:id",
  "/companies/:id/employees/new" = "/companies/:id/employees/new",
  "/companies/:id/employees/import" = "/companies/:id/employees/import",
  "/companies/:id/employees/bulk-archive" = "/companies/:id/employees/bulk-archive",
  "/companies/:id/users/new" = "/companies/:id/users/new",
  "/companies/:id/users/import" = "/companies/:id/users/import",
  "/companies/:id/users/bulk-archive" = "/companies/:id/users/bulk-archive",
  "/companies/:id/files" = "/companies/:id/files",
  "/companies/:id/manage-flows" = "/companies/:id/manage-flows",
  "/companies/:id/history" = "/companies/:id/history",
  "/companies/:id/links" = "/companies/:id/links",
  "/companies/:id/locations" = "/companies/:id/locations",
  "/companies/:id/plan" = "/companies/:id/plan",
  "/companies/:id/settings" = "/companies/:id/settings",
  "/companies/:id/sub-companies" = "/companies/:id/sub-companies",
  "/companies/:id/sub-companies/new" = "/companies/:id/sub-companies/new",
  "/companies/:id/sub-companies/:subCompanyId" = "/companies/:id/sub-companies/:subCompanyId",
  "/companies/:id/subscription" = "/companies/:id/subscription",
  "/companies/:id/billing" = "/companies/:id/billing",
  "/companies/:id/whitelabel" = "/companies/:id/whitelabel",
  "/companies/:id/teams" = "/companies/:id/teams",
  "/companies/:companyId/teams/:id" = "/companies/:companyId/teams/:id",
  "/companies/:companyId/teams/:id/employees" = "/companies/:companyId/teams/:id/employees",
  "/companies/:companyId/teams/:id/employees/import" = "/companies/:companyId/teams/:id/employees/import",
  "/companies/:companyId/teams/:id/users" = "/companies/:companyId/teams/:id/users",
  "/companies/:companyId/teams/:id/cases" = "/companies/:companyId/teams/:id/cases",
  "/companies/:companyId/teams/:id/edit" = "/companies/:companyId/teams/:id/edit",
  "/companies/:companyId/teams/:id/delete" = "/companies/:companyId/teams/:id/delete",
  "/companies/:id/fourth" = "/companies/:id/fourth",
  "/companies/:id/itrent" = "/companies/:id/itrent",
  "/companies/:companyId/help-requests" = "/companies/:companyId/help-requests",
  "/companies/:companyId/help-requests/:id" = "/companies/:companyId/help-requests/:id",
  "/flows/:id" = "/flows/:id",
  "/flows/:id/steps" = "/flows/:id/steps",
  "/flows/:id/draft" = "/flows/:id/draft",
  "/flows/:id/comments" = "/flows/:id/comments",
  "/flows/:id/results" = "/flows/:id/results",
  "/flows/:id/results/:resultId" = "/flows/:id/results/:resultId",
  "/flows/report" = "/flows/report",
  "/admin/emails" = "/admin/emails",
  "/admin/emails/:id" = "/admin/emails/:id",
}

export function buildRoute(
  route: eRoutes,
  params: Record<string, any>,
  opts: { qs?: Record<string, string | null> } = {},
) {
  let str: string = route

  for (const key in params) {
    str = str.replace(`:${key}`, params[key])
  }

  if (opts.qs) {
    const searchParams = new URLSearchParams()
    for (const key in opts.qs) {
      if (opts.qs[key] !== null) {
        searchParams.append(key, opts.qs[key]!)
      }
    }
    str += `?${searchParams.toString()}`
  }

  return str
}

// eslint-disable-next-line prettier/prettier
export type IERoute = keyof typeof eRoutes
